// #TODO 30-04-2018_FG Terminer les interfaces

import { IYii, Yii } from 'libraries/interfaces/Yii';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin, forkJoin as observableForkJoin, Observable, of as observableOf, Subscription } from 'rxjs';
import { catchError, debounceTime, first, map, pluck, tap } from 'rxjs/operators';
import { FormService } from 'libraries/service/form/form.service';
import { HotelService } from 'libraries/hotel/services/hotel.service';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { BookingService } from 'libraries/hotel/services/booking.service';
import { SharedData } from 'libraries/hotel/shared-data';
import { ModalComponent } from 'libraries/ui_modal/modal.component';
import { BreadcrumbService } from 'libraries/hotel/services/breadcrumb.service';
import { IRemark } from 'libraries/hotel/models/remark';
import { IGetBookingsStayResponse, IRemark as IRemarkNote, ISectorStay } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { IMenuDetails } from 'libraries/hotel/models/menu-details';
import { NOTIFICATIONS } from 'libraries/hotel/initializer';
import { ICurrency } from 'libraries/service/resources/model/search/ICurrency';
import { INotification, NotificationType } from 'libraries/interfaces/INotification';
import { IOptionsCardForm } from 'libraries/module/formbuilder/forms/card-form/card-form.component';
import { ITraveller } from 'libraries/service/resources/model/booking/ITraveller';
import { IAgesConfig, TravellerFormComponent } from 'libraries/module/formbuilder/forms/travellerForm/travellerForm.component';
import { FormGroup } from '@angular/forms';
import { ICurrencies, IProperty } from 'libraries/service/resources/hotel/ISearchResponse';
import { IPhone, IPostHotelBookingsCreateRequest, IPostHotelBookingsCreateResponse } from 'libraries/service/resources/hotel/IPostHotelBookingsCreate';
import { IHotelQuoteResourceResponse } from 'libraries/service/resources/hotel/hotel-quotation';
import { IResortFeeDetail, ISalesInformation } from 'libraries/service/resources/model/search/IBooking';
import { IRoomDetail } from 'libraries/hotel/models/quote';
import { RoomService } from 'libraries/hotel/services/room/room.service';
import { ConfigurationResourceService } from 'libraries/service/resources/configuration/configurationResource.service';
import { IMarkerPoint } from 'libraries/map/IPoint';
import { NotepadComponent, NOTEPAD_EDITOR_PERMISSION } from 'libraries/component/notepad/notepad.component';
import { INotepad } from "libraries/service/resources/booking/interfaces/notepad.interface";
import { ILabels } from "libraries/interfaces/ILabels";
import { QuotationToBookingMappingService } from "libraries/service/quotation-to-booking-service/quotation-to-booking-mapping.service";
import {EmergencyContactComponent } from 'app_iaqobohotel/quotation-page/components/emergency-contact/emergency-contact.component';
import { PermissionResourceService } from 'libraries/service/resources/permission/permissionResource.service';
import { UrlHelperService } from "libraries/service/url-helper/url-helper.service";
import { EStayPermissions } from "libraries/enums/e-stay-permissions";
import {
    IIqbhBookFormConfig, IIqbhBookFormConfigEmergencyContactForm, INoteForm, ICheckNote, IShowConditionCondition
} from "libraries/interfaces/i-iaqoboh-reservation-form-config";
import { RESERVATION_FORM } from "app_iaqobohotel/quotation-page/containers/quotation/json-default/reservation-form-default";
import { EHosts } from "libraries/enums/EHosts";

@Component({
    selector: 'quotation',
    templateUrl: './quotation.component.html',
    styleUrls: ['./quotation.component.css']
})
export class QuotationComponent implements OnInit, OnDestroy {
    public Yii: IYii = Yii;

    @ViewChild('detailsModal', {static: false})
    public detailsModal: ModalComponent;

    @ViewChild('maintenanceModal', {static: false})
    public maintenanceModal: ModalComponent;

    @ViewChild('travellerForm', {static: false})
    public travellerForm: TravellerFormComponent;

    @ViewChild('emergencyContact', {static: false})
    public emergencyContact: EmergencyContactComponent;
    public configuration: IIqbhBookFormConfigEmergencyContactForm;

    @ViewChild('notepadComponent', {static: false})
    public notepadComponent: NotepadComponent;

    @Input()
    public quotationWtb: IHotelQuoteResourceResponse;

    public iaqobohReservationFormParamsConfig: IIqbhBookFormConfig;

    public travellers;
    public selectedMenuDetailsItem: string = 'description';
    public formConfig: IOptionsCardForm;
    public serviceNotes: INotepad[];
    public menuDetailsItems: IMenuDetails[] = [
        {
            code: 'description',
            name: Yii.t('wui-iqbh-js', 'Descriptions'),
            exist: true,
            selected: true
        },
        {
            code: 'informations',
            name: Yii.t('wui-iqbh-js', 'Informations pratiques'),
            exist: true,
            selected: false
        }
    ];

    public description: IProperty;
    public travellersList;
    public quotation: IHotelQuoteResourceResponse;
    public error: INotification = NOTIFICATIONS;
    public loader: {
        active: boolean;
        message: string;
    } = {
        active: false,
        message: null
    };

    public existingTravellerInformations = null;
    public existingPhoneNumber: IPhone = null;
    public existingEmail: string = null;
    public currency: ICurrency;
    public currencies: ICurrencies;
    public isTravellersFormValid: boolean = false;
    public resortFeeByRoom: Map<string, IResortFeeDetail> = new Map();
    public salesInformationByRoom: Map<string, ISalesInformation> = new Map();
    public ageLimitConfig: IAgesConfig;

    public mappedBooking: Partial<IGetBookingsStayResponse>;
    public mappedSector: ISectorStay;

    public isNotepadPermission: boolean;

    public isTermsOfUseAccepted: boolean = null;
    public servicesFormConfiguration: INoteForm;
    public readonly wording: ILabels = {
        specialRequests: Yii.t('wui-iqbh-js', 'Demandes spéciales'),
        notes: Yii.t('wui-iqbh-js', 'Notes'),
        searchResume: Yii.t('wui-iqbh-js', 'Résumé de votre recherche'),
        backToSearch: Yii.t('wui-iqbh-js', 'Retourner à la recherche'),
        accomodation: Yii.t('wui-iqbh-js', 'Hébergement'),
        details: Yii.t('wui-iqbh-js', 'Détails'),
        book: Yii.t('wui-iqbh-js', 'Réserver')
    };

    public readonly notepadEditorPermission: string = NOTEPAD_EDITOR_PERMISSION;

    public distinct: boolean = false;
    public notes: IRemarkNote[] = [];
    public canAddEmergencyContact: boolean = false;
    public canAddServices: boolean = false;
    public isPhoneRequired: boolean;

    private subscription: Subscription;
    private request: IPostHotelBookingsCreateRequest;
    private viewParams: string;

    constructor(
        private readonly hotelService: HotelService,
        private readonly quotationService: QuotationService,
        private readonly bookingService: BookingService,
        private readonly formService: FormService,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly sharedData: SharedData,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly roomService: RoomService,
        private readonly configurationResourceService: ConfigurationResourceService,
        private readonly quotationToBookingMappingService: QuotationToBookingMappingService,
        private readonly permissionResource: PermissionResourceService,
        private readonly urlHelperService: UrlHelperService,
    ) {
    }

    public get rooms(): IRoomDetail[] {
        return this.roomService.formatRoomsDetailFromQuote(
            this.roomService.rooms = Object.values(this.quotation.quote.detail)
        );
    }

    public ngOnInit(): void {
        this.permissionResource.hasPermission(NOTEPAD_EDITOR_PERMISSION).subscribe({
            next: (isPermitted: boolean): void => {
                this.isNotepadPermission = isPermitted;
            }
        });


        if (!this.quotationWtb) {
            this.sharedData.getData('request').subscribe((request) => {
                if (request) {
                    this.existingTravellerInformations = request.traveller;
                    this.existingPhoneNumber = request.emergencyContact;
                    this.existingEmail = request.emergencyContact;
                }
            });

            observableForkJoin(
                observableOf(this.activatedRoute.snapshot.data.quotation),
                this.getAgeLimitConfig()
            ).pipe(
                map(([quotation, ageLimitConfig]: [any, IAgesConfig]) => {
                    const fromGet: boolean = Boolean(quotation && quotation.quote.quote);
                    const quoteData: IHotelQuoteResourceResponse = fromGet ? quotation.quote : quotation;

                    this.mappedBooking = this.quotationToBookingMappingService.mapBooking(quoteData);
                    this.mappedSector = this.quotationToBookingMappingService.mapSector(quoteData);
                    this.ageLimitConfig = {
                        ...ageLimitConfig,
                        journeyDate: moment(quoteData.segment[0].begin).toDate()
                    };
                    return quoteData;
                }),
                tap((quotation: IHotelQuoteResourceResponse) => {
                    this.currencies = quotation.currency;
                    this.currency = quotation.currency[Object.keys(quotation.quote.total.cost)[0]];

                    this.hotelService.setCurrencies(quotation.currency);
                    this.quotationDispatching(quotation);
                    this.computeConfiguration();
                    this.resortFeeByRoom = this.roomService.createMapByRoom(quotation.quote.resortFees);
                    this.salesInformationByRoom = this.roomService.createMapByRoom(quotation.quote.salesInformation);
                }),
                first())
                .subscribe();

            this.subscription = this.formService.formData$.pipe(
                debounceTime(500))
                .subscribe((remark: INotepad[]) => {
                    this.request = {...this.request, remark};
                });
        } else {
            this.hotelService.setCurrencies(this.quotationWtb.currency);
            this.quotationDispatching(this.quotationWtb);
            this.computeConfiguration();
        }


    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public getTravellers(): ITraveller[] {
        const existingTravellerInformations = this.existingTravellerInformations ?
            Object.keys(this.existingTravellerInformations)
                .map((key) => this.existingTravellerInformations[key]) :
            [];
        const travellersList = Object.keys(this.travellersList)
            .map((key) => this.travellersList[key]);
        if (existingTravellerInformations.length) {
            return existingTravellerInformations.length !== travellersList.length ?
                travellersList :
                existingTravellerInformations;
        }

        return travellersList;
    }

    public book(): void {

        if (!this.travellerForm.isValid()) {
            this.error = {
                type: NotificationType.Error,
                active: true,
                message: this.Yii.t('wui-iqbh-js', 'Le formulaire des voyageurs n\'a pas été correctement rempli.')
            };
            return;
        }

        let note: INotepad[] = this.notepadComponent ? this.notepadComponent.extractNotes() : [];
        if (this.notes === null) {
            this.error = {
                type: NotificationType.Error,
                active: true,
                message: this.Yii.t('wui-iqbh-js', 'Les notes comportent des caractères invalides.')
            };
            return;
        }

        note = [
            ...note,
            ...(this.serviceNotes || []),
        ];

        if (this.emergencyContact) {

            if (!this.emergencyContact.form.valid) {
                const emergencyContactInformation: IPhone = this.emergencyContact.extractPhoneNumber();
                if(emergencyContactInformation){
                    if (!emergencyContactInformation.number && this.isPhoneRequired) {
                        this.error = {
                            type: NotificationType.Error,
                            active: true,
                            message: Yii.t('wui-iqbh-js', 'Le numéro de téléphone est requis.')
                        };

                        return;
                    } else if(!this.emergencyContact.isValidPhoneNumber){
                        this.error = {
                            type: NotificationType.Error,
                            active: true,
                            message: Yii.t('wui-iqbh-js', 'Le numéro de téléphone est invalide.')
                        };
                        return;
                    }else if (emergencyContactInformation.number) {
                        this.request = {
                            ...this.request,
                            emergencyContact: emergencyContactInformation,
                        };
                    }
                }else{
                    if(!this.emergencyContact.isValidPhoneNumber){
                        this.error = {
                            type: NotificationType.Error,
                            active: true,
                            message: Yii.t('wui-iqbh-js', 'Le numéro de téléphone est invalide.')
                        };
                    }else {
                        this.error = {
                            type: NotificationType.Error,
                            active: true,
                            message: Yii.t('wui-iqbh-js', 'Les informations de contact sont requises.')
                        };
                    }
                    return;
                }
            }else{
                if(this.emergencyContact.isValidPhoneNumber){
                    this.request = {
                        ...this.request,
                        emergencyContact: this.emergencyContact.extractPhoneNumber()
                    };
                }else{
                    this.error = {
                        type: NotificationType.Error,
                        active: true,
                        message: Yii.t('wui-iqbh-js', 'Le numéro de téléphone est invalide.')
                    };

                    return;
                }

            }
        }

        this.error = {
            type: NotificationType.Error,
            active: false,
            message: null
        };

        this.loader = {
            active: true,
            message: Yii.t('wui-iqbh-js', 'Réservation en cours ...')
        };

        this.request = {
            ...this.request,
            travellers: this.getTravellerInformations(this.travellerForm.form.value),
        };

        const request: IPostHotelBookingsCreateRequest = this.bookingService
            .createRequest(this.quotation, this.request, note);

        this.sharedData.setData('request', request);

        forkJoin([
            this.quotationService.create(request),
            this.permissionResource.hasPermission(EStayPermissions.SHARED_HOST_SHOW),
        ])
            .pipe(
                catchError((error: Error): Observable<unknown> => {
                    this.loader = {
                        active: false,
                        message: ''
                    };

                    this.error = {
                        type: NotificationType.Error,
                        active: true,
                        message: error.message
                    };

                    return observableOf(null);
                }))
            .subscribe(([booking, canShowHost]: [IPostHotelBookingsCreateResponse, boolean]): void => {
                if (booking) {
                    this.loader = {
                        active: false,
                        message: ''
                    };

                    this.sharedData.setData('booking', booking);
                    const key: string = canShowHost ? booking.booking.syscode : this.urlHelperService.encodeUrlPart(booking.booking.syscode);

                    this.router.navigate(['/iaqobohotel', 'booking', key]);
                }
            });
    }

    public openModal() {
        this.selectedMenuDetailsItem = 'description';

        this.menuDetailsItems.map((item: IMenuDetails): IMenuDetails => {
            item.selected = item.code === 'description' ? true : false;
            return item;
        });

        this.detailsModal.show();
    }

    public closeDetailsModal() {
        this.detailsModal.hide();
    }

    public changeTab(tabCode: string): void {
        this.selectedMenuDetailsItem = tabCode;

        this.menuDetailsItems.map((item: IMenuDetails): IMenuDetails => {
            item.selected = item.code === tabCode;
            return item;
        });
    }

    public goToSearch(): void {
        this.sharedData.setData('request', {
            segment: this.quotation.segment,
            traveller: this.getTravellerInformations(this.travellerForm.form.value),
            quantity: this.quotation.quantity
        });

        this.breadcrumbService.setItems({
            search: {
                router: '/iaqobohotel/search/' + this.quotation.trip.key,
                params: {view: this.viewParams},
                disabled: false
            }
        });

        this.router.navigate(
            ['iaqobohotel', 'search', this.quotation.trip.key],
            {
                queryParams: {
                    view: this.viewParams
                }
            }
        );
    }

    public checkTravellersFormValidity(formGroup: FormGroup): void {
        this.isTravellersFormValid = formGroup.valid;
    }

    public getTravellerInformations(travellers: any): any {
        let travellersList = {};

        travellers.traveller.forEach((trav, index) => {
            travellersList = {...travellersList, ['T_' + (index + 1)]: trav};
        });

        return travellersList;
    }


    public checkNoteChange(noteArray: string []): void {
        this.serviceNotes = noteArray.map((note: string): INotepad => {
            return {
                text: note,
                authorId: null,
                name: null,
                whenLastUpdated: new Date().toISOString(),
            };
        });
    }

    // Merge property and dateCancellation
    public getHotelInformations() {
        return {
            ...(this.quotation ? this.quotation.property[this.quotation.quote.property] : {}),
            dateLastCancellationWithoutPenalty: this.quotation?.quote.dateLastCancellationWithoutPenalty,
            total: this.quotation?.quote.total,
            host: this.quotation?.quote.host,
            status: this.quotation?.quote.status,
        };
    }

    public getPoints(overlay): IMarkerPoint[] {
        return [
            {
                latitude: Number(overlay.latitude),
                longitude: Number(overlay.longitude)
            }
        ];
    }

    private getIaqobohReservationFormParamsConfig(): Observable<IIqbhBookFormConfig> {
        return this.configurationResourceService.get(
            ["wui", "app_iaqobohotel", "config", "reservation-form", "reservation-form.json"],
            RESERVATION_FORM);
    }

    private getAgeLimitConfig(): Observable<IAgesConfig> {
        return this.configurationResourceService.get(["wui", "shared_hotel", "config", "forms", "form_hotel.json"]).pipe(
            pluck('traveller'));
    }

    private computeConfiguration(): void {
        this.getIaqobohReservationFormParamsConfig().subscribe((config: IIqbhBookFormConfig): void => {
            this.iaqobohReservationFormParamsConfig = config;
            if (config.emergencyContactForm.showCondition.isAlways) {
                this.canAddEmergencyContact = true;
            } else {
                const choosenQuotationHost: string | { code: string; } = this.getHotelInformations().host;
                const host: string = typeof choosenQuotationHost === 'string' ?
                    choosenQuotationHost :
                    choosenQuotationHost.code;
                if (config.emergencyContactForm.showCondition.conditionArray?.length) {
                    const foundedCondition: { host: string } = config.emergencyContactForm.showCondition.conditionArray
                        .find((condition: { host: string }): boolean => {
                            return condition.host === host;
                        });

                    this.canAddEmergencyContact = Boolean(foundedCondition);
                } else {
                    this.canAddEmergencyContact = false;
                }
                this.canAddServices = Boolean(config.servicesForm?.checkboxArray?.length) &&
                    (
                        config.servicesForm.showCondition?.isAlways ||
                        Boolean(config.servicesForm.showCondition.conditionArray
                            .find((conditionItem: IShowConditionCondition): boolean => conditionItem.host === choosenQuotationHost))
                    );
                this.servicesFormConfiguration = config?.servicesForm;
            }
        });
    }

    private quotationDispatching(quotation: IHotelQuoteResourceResponse): void {
        quotation.property[quotation.quote.property].host = quotation.quote.host as string;
        this.quotation = quotation;
        this.isPhoneRequired = this.quotation.quote.host === EHosts.EXPEDIA;
        this.hotelService.setTravellersDistribution({
            segment: quotation.segment,
            traveller: quotation.traveller
        });

        this.activatedRoute.queryParams.subscribe((params) => {
            this.viewParams = params.view;

            this.breadcrumbService.setItems({
                search: {
                    router: `/iaqobohotel/search/${quotation.trip.key}`,
                    disabled: false,
                    params: {view: this.viewParams}
                },
                quotation: {
                    router: `/iaqobohotel/quotation/${quotation.key}`,
                    active: true,
                    disabled: false,
                    params: {view: this.viewParams}
                }
            });
        });

        this.travellersList = quotation.traveller;
        this.travellers = this.hotelService.getTravellersDistribution();
    }
}
